export default {
	sec_01: {
		title: {
			one: 'オフライン加盟店での',
			two: 'ご利用方法',
		},
		desc: {
			one: 'スピーディーに決済ができます。',
			two: '現金やクレジットカードがなくてもスマホさえあれば',
			three: '簡単に支払いができるJP WOLRD Payをご利用ください。',
		},
		btn: {
			one: '会員登録',
			two: 'ログイン',
		},
	},
	sec_02: {
		title: {
			one: 'JP WOLRD を利用した決済方法',
		},
		step: {
			one: {
				one: 'スマホで',
				two: 'JP WOLRD Payを',
				three: '選択して実行してください。',
			},
			two: {
				one: 'お財布をタップして',
				two: '「オフラインショップ決済」を選択してください。',
			},
			three: {
				one: 'QRコードをPOSレジに',
				two: 'スキャンすれば決済完了です。',
			},
		},
	},
	sec_04: {
		title: '未来の貨幣システムへようこそ。',
		cards: {
			one: {
				title: '安全な決済',
				description: {
					one: 'オフライン決済時にお客様のデー',
					two: 'タは残りません。',
				},
			},
			two: {
				title: 'お近くの加盟店で',
				description: {
					one: 'いつでも、どこでも、JP WOLRD Pay',
					two: '加盟店を検索してご利用ください。',
				},
			},
			three: {
				title: 'キャッシュレス',
				description: {
					one: 'まだ現金を持ち歩きますか?スマ',
					two: 'ホでJPWORLDPAYをすぐ使うことができます。',
				},
			},
		},
	},
	sec_05: {
		title: '販売加盟店の方も 簡単にアクセスできます。',
		desc: {
			one: 'JP WOLRD Payキオスクに販売物品を登録するだけで完了です。',
			two: '支払いはJP WOLRD Payキオスクが行います。',
		},
	},
};
